<template>
  <div>
    <el-row :gutter="20">
      <!--      <el-col :span="3">-->
      <!--        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%">去开卡</el-button>-->
      <!--      </el-col>-->
      <!--      <el-col :span="5">-->
      <!--        <el-input placeholder="members表id" v-model="params.members_id" style="width: 100%">-->
      <!--          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>-->
      <!--        </el-input>-->
      <!--      </el-col>-->
      <!--      <el-col :span="5">-->
      <!--        <el-input placeholder="会员姓名" v-model="params.userName" style="width: 100%">-->
      <!--          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>-->
      <!--        </el-input>-->
      <!--      </el-col>-->
      <!--      <el-col :span="5">-->
      <!--        <el-input placeholder="会员电话" v-model="params.phone" style="width: 100%">-->
      <!--          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>-->
      <!--        </el-input>-->
      <!--      </el-col>-->
      <!--      <el-col :span="5">-->
      <!--        <el-input placeholder="员工电话" v-model="params.pharmacistTel" style="width: 100%">-->
      <!--          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>-->
      <!--        </el-input>-->
      <!--      </el-col>-->
      <!--      <el-col :span="5">-->
      <!--        <el-input placeholder="" v-model="params.benefitNo" style="width: 100%">-->
      <!--          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>-->
      <!--        </el-input>-->
      <!--      </el-col>-->
      <!--      <el-select v-model="params.res" placeholder="结果状态" clearable @change="searchData" style="width: 15%">-->
      <!--        <el-option-->
      <!--          v-for="item in resList"-->
      <!--          :key="item.value"-->
      <!--          :label="item.label"-->
      <!--          :value="item.value">-->
      <!--        </el-option>-->

      <!--      </el-select>-->
    </el-row>
    <el-table :data="userList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="distribution_feedback_id" label="id" width="100"></el-table-column>
      <el-table-column prop="feedback_type" label="反馈类型" width="250">
        <template slot-scope="scope">
          {{scope.row.feedback_type}}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" width="250">
        <template slot-scope="scope">
          <!--        <el-tag :color="scope.row.tag_color" size="mini" :style="'color:'+scope.row.font_color"></el-tag>-->
          {{scope.row.mobile}}
        </template>
      </el-table-column>

      <el-table-column prop="feedback_content" label="反馈内容" width="250">
        <template slot-scope="scope">
          {{scope.row.feedback_content}}
        </template>
      </el-table-column>
      <el-table-column prop="distributor_id" label="店铺Id" width="250">
        <template slot-scope="scope">
          {{scope.row.distributor_id}}
        </template>
      </el-table-column>
      <el-table-column prop="feedback_img" label="反馈图片" width="250">
        <template slot-scope="scope">
          <!--          {{scope.row.pic_url}}-->
          <el-image  :src="scope.row.feedback_img" style="width: 100px;height: 60px" mode="modeWidth"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="created" label="发布时间" width="250">
        <template slot-scope="scope">
          {{scope.row.created}}
        </template>
      </el-table-column>
      <!--      <el-table-column label="操作">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div class="operating-icons">-->
      <!--            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>-->
      <!--            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column prop="userNo" label="众安那边给到的用户编号" width="250">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{scope.row.userNo}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column prop="sex" label="性别" width="250">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{scope.row.sex}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->

<!--      <el-table-column prop="pay_time" label="领取权益的时间" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.pay_time}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="操作" width="380">-->
<!--        <template slot-scope="scope">-->

<!--          <el-button type="text" @click="editAction(scope.$index, scope.row)" >拉取订单</el-button>-->


<!--          &lt;!&ndash;          <el-button type="text" @click="editAction(scope.$index, scope.row)" v-if="scope.row.employee==''">编辑</el-button>&ndash;&gt;-->
<!--        </template>-->
<!--      </el-table-column>-->
      <!--      <el-table-column prop="pharmacistTel" label="签名图片地址" width="250">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{scope.row.sign_url}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column prop="openId" label="openId" width="250">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{scope.row.openId}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column prop="unionid" label="unionid" width="250">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{scope.row.unionid}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column prop="res" label="结果" width="250">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{scope.row.res}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column prop="msg" label="提示" width="250">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{scope.row.msg}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <!--      <el-table-column prop="createdate" label="创建时间" width="250">-->
      <!--        <template slot-scope="scope">-->
      <!--          {{scope.row.createdate}}-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="操作">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div v-if="scope.row.res=='false'">-->
      <!--            <div class="operating-icons">-->
      <!--              <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>-->
      <!--              &lt;!&ndash;            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>&ndash;&gt;-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </template>-->

      <!--      </el-table-column>-->


    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.page_size">
      </el-pagination>
    </div>
    <!--    <el-dialog title="添加推荐人" width="40%" :visible.sync="employeeDialog" :before-close="handleCancelLabelsDialog">-->
    <!--      <template>-->
    <!--        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">-->


    <!--          <el-form-item class="content-left" label="日期" prop="time">-->

    <!--            <el-input placeholder="拉取日期" v-model="form.time"></el-input>-->
    <!--          </el-form-item>-->

    <!--          <el-form-item class="content-center">-->
    <!--            <el-button type="primary" @click="saveTimeData">确定保存</el-button>-->
    <!--          </el-form-item>-->
    <!--        </el-form>-->
    <!--      </template>-->
    <!--    </el-dialog>-->
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  // eslint-disable-next-line no-unused-vars
  import {Message} from 'element-ui'
  // eslint-disable-next-line no-unused-vars
  import {getFeedBack} from '../../../api/distributorfeedback'

  export default {
    data() {
      return {

        isEdit: false,
        userList: [],
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          page_size: 20,
          card: '',
          employee_id: '',
          pharmacistTel: '',
          phone: '',
          store_inkid: ''

        },

        resList: [{label: 'true', value: 'true'},
          {label: 'false', value: 'false'}
        ],
        form: {
          id: '',

          description: ''
        },

        employeeDialog: false,
        predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      saveTimeData() {
        this.employeeDialog = false
        if (this.form.id) {
          // eslint-disable-next-line no-undef
          pullOrder(this.form).then(res => {

            this.$message({
              type: 'success',
              message: '获取成功'
            })
            this.getDataList()

          })
        } else {
          this.$message.error('缺少Id')
          this.getDataList()
        }
      },
      // eslint-disable-next-line camelcase
      handleCurrentChange(page_num) {
        // eslint-disable-next-line camelcase
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate() { // 添加
        this.employeeDialog = true
        // eslint-disable-next-line standard/object-curly-even-spacing
        this.form = {tag_id: '', tag_name: '', tag_color: '#ff1939', font_color: '#ffffff', description: ''}
      },
      editAction(index, row) { // 编辑
        this.form = row
        this.employeeDialog = true
      },
      preview(index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData() {
        if (!(/^1[3-9][0-9]\d{8}$/.test(this.params.phone)) && this.params.phone != '') {
          this.$message.error('请输入正确手机号')
        } else if (!(/^1[3-9][0-9]\d{8}$/.test(this.params.pharmacistTel)) && this.params.pharmacistTel != '') {
          this.$message.error('请输入正确手机号')
        } else {
          this.params.page = 1
          this.getDataList()
        }
      },
      getDataList() {
        this.loading = true
        getFeedBack(this.params).then(response => {
          this.userList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
          // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },

      getTaskTime(strDate) {
        let date = new Date(strDate)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let str = y + '-' + m + '-' + d
        return str
      },
      getTimeStr(date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog() {
        this.employeeDialog = false
      },

    },
    mounted() {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 10px;

    img {
      width: 90%;
    }
  }

  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }

  .service-label .el-checkbox:first-child {
    margin-left: 15px;
  }

  .service-label .el-input:first-child {
    margin-left: 15px;
  }

  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }

  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100% !important;
    }

    img {
      width: 100%;
    }
  }

  .grid-attribute {
    table {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// distributorfeedback.vue?34975ac6